import '../styles/home.css';
import '../styles/money.css';
import '../styles/product.css';
import React, { useEffect } from 'react';
import ErrorBoundary from './ErrorBoundary';
import { motion, useReducedMotion } from 'framer-motion';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import SyncStatus from './SyncStatus';
import AppNavigation from './AppNavigation';
import AppWalkthrough from './AppWalkthrough';
import PayOnboarding from './PayOnboarding';
import { useData } from '../contexts/DataContext';

const Layout = () => {
  useAuth();
  const reducedMotion = useReducedMotion();
  const { needsOnboarding, completeOnboarding, finishOnboarding } = useData();
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
    const main = document.querySelector('main');
    if (main) main.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
  }, [location.pathname,reducedMotion]);
  // First-run gate: brand-new users set up their pay before entering the app.
  if (needsOnboarding) {
    return <PayOnboarding onComplete={completeOnboarding} onStart={finishOnboarding} onImport={()=>{finishOnboarding();navigate('/app/records?import=1');}} />;
  }

  return (
    <div className="st-app-shell min-h-[100dvh] bg-background text-foreground flex flex-col pt-safe">
      <SyncStatus />
      <AppWalkthrough />

      <main
        className="w-full flex-grow overflow-y-auto touch-manipulation"
      >
        {/* Full-width scroll area; an inner block owns the max-width + centering
            so it stays centred on iOS WebKit (a flex item with max-width can
            left-bias under align-items:stretch). */}
        <div className="st-content-container w-full max-w-6xl mx-auto pt-3 px-4">
          <ErrorBoundary>
            <motion.div
              key={location.pathname}
              initial={reducedMotion ? false : { opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0, transitionEnd: { transform: "none" } }}
              transition={{ duration: 0.2, ease: 'easeOut' }}
            >
              <Outlet />
            </motion.div>
          </ErrorBoundary>
        </div>
      </main>

      <AppNavigation className="flex-shrink-0 pb-safe" />

    </div>
  );
};

export default Layout;
